import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { NgxQueryModule } from '@zhongruigroup/ngx-query';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxDatatableFooterModule } from 'ngx-datatable-footer';

import { DynamicFormRuntimeModule, FormDataService } from 'zr-dynamic-form/dynamic-form-runtime';
import { DynamicFormCommonModule } from 'zr-dynamic-form/dynamic-form-common';
import { DynamicFormDesignerModule } from 'zr-dynamic-form/dynamic-form-designer';

import { DynamicFormDynamicPageRoutingModule } from './dynamic-form-dynamic-page-routing.module';

import { ListComponent } from './partial/list/list.component';
import { AddComponent } from './partial/add/add.component';
import { EditComponent } from './partial/edit/edit.component';
import { DetailComponent } from './partial/detail/detail.component';
import { DynamicFormTemplateCommonComponent } from './partial/dynamic-form-template-common/dynamic-form-template-common.component';
import { RouterModule } from '@angular/router';
import { NgxQueryDynamicCustomComponent } from './partial/ngx-query-dynamic-custom/ngx-query-dynamic-custom.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgxQueryModule,
    NgxDatatableModule,
    NgxDatatableFooterModule,
    SweetAlert2Module,
    DynamicFormCommonModule,
    DynamicFormDesignerModule,
    DynamicFormRuntimeModule,
    DynamicFormDynamicPageRoutingModule,
    FormsModule
  ],
  declarations: [
    ListComponent,
    AddComponent,
    EditComponent,
    DetailComponent,
    DynamicFormTemplateCommonComponent,
    NgxQueryDynamicCustomComponent
  ],
  exports: [DynamicFormTemplateCommonComponent],
  providers: [FormDataService]
})
export class DynamicFormDynamicPageModule {}
